import React, { useState } from 'react';
import Chip from '@mui/material/Chip';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Box from '@mui/material/Box';
import { IDropdown } from '../model';

interface DropdownProps {
    options: IDropdown;
}

const Dropdown: React.FC<DropdownProps> = ({ options }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleChipClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleMenuItemClick = (action: () => void) => {
        if (action) {
            action();
        }
        handleMenuClose();
    };

    return (
        <>
            <Chip
                label={
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            color: 'black',
                            fontWeight: 'bold'
                        }}
                    >
                        {options.placeholder}
                        <KeyboardArrowDownIcon
                            sx={{
                                transition: 'transform 0.3s ease',
                                transform: open ? 'rotate(180deg)' : 'rotate(0deg)'
                            }}
                        />
                    </Box>
                }
                onClick={handleChipClick}
                clickable
                sx={{
                    backgroundColor: 'grey',
                    borderRadius: '15px',
                    padding: '8px 12px',
                    maxHeight: 'max-content',
                    '&:hover': {
                        backgroundColor: '#f5f5f5'
                    }
                }}
            />
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                sx={{ '& .MuiPaper-root': { minWidth: '200px', backgroundColor: 'grey', color: 'black' } }}
            >
                {options.data.map((option, index) => (
                    <MenuItem key={index} onClick={() => handleMenuItemClick(option.action)}>
                        {option.label}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default Dropdown;
